import { render, staticRenderFns } from "./ButtonBackToDashboard.vue?vue&type=template&id=3d1f5e22&scoped=true&"
import script from "./ButtonBackToDashboard.vue?vue&type=script&lang=ts&"
export * from "./ButtonBackToDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBackToDashboard.vue?vue&type=style&index=0&id=3d1f5e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f5e22",
  null
  
)

export default component.exports